<template>
  <div data-grm-comp="RoomVideo" class="room-video-wrapper">
    <!--
    <div class="loading-dots"
         v-if="useLoadingImage"
         :class="{
           hide: !loading
         }"
    ><span></span></div>
    -->
    <div class="room-video"
        v-if="canvas" ref="canvasLayer"
    ></div>
    <video class="room-video"
      v-if="!canvas"
      webkit-playsinline
      playsinline
      autoplay
      ref="video"
      :muted="muted"
      @resize="onEvent"
      @play="onEvent"
      @playing="onEvent"
      @pause="onEvent"
      @loadedmetadata="onEvent"
      @loadeddata="onEvent"
       @stalled="onEvent"
       @emptied="onEvent"
       @error="onEvent"
       @progress="onEvent"
    ></video>
    <div class="user-sticker-layer">
      <img v-for="sticker in videoStickerList" :key="sticker.userId + sticker.imagePath" :src="`${cdnUrl}/${container}/${sticker.imagePath}`" :style="{...sticker.setting.style, position: 'absolute'}" />
    </div>
    <div class="user-profile-image-container" v-show="!canvas && loading">
      <UserProfileImage class="user-profile-image"
                        :user-id="user.userId"
                        :class="{
               'blank-profile-image': isBlankProfileImage
            }"
                        :useBlankImage="true"
                        @emitImageNotFoundEvent="isBlankProfileImage=true"
      />
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import UserProfileImage from "@/components/Room/User/UserProfileImage.vue";

export default {
  name: 'RoomVideo',
  components: {UserProfileImage},
  props: {
    muted: {
      type: Boolean,
      default: true
    },
    myVideo: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: function(){
        return {
          userId: null,
          screenShare: false,
          _createdAt: 0
        };
      }
    },
  },
  data() {
    return {
      isBlankProfileImage: true,
      loading: true,
      canvas: null,
      cdnUrl: process.env.VUE_APP_AZURE_CDN_URL,
      container: process.env.VUE_APP_AZURE_CONTAINER
    }
  },
  computed: {
    ...mapGetters('room', ['deviceSettings']),
    ...mapGetters('camstudy', [
      'getCamStudyUser'
    ]),
    ...mapGetters('coordi', ['userStickerList']),
    paused: function(){
      return this.$refs.video.paused;
    },
    videoStickerList() {
      return this.userStickerList(this.user.userId)
    },
    videoTrack() {
      const {video} = this.$refs;
      if(!video) return null;
      const track = video.srcObject?.getVideoTracks()[0];
      return track;
    }
  },
  watch: {
    canvas: function(value){
      const append = () => {
        if(!this.$refs.canvasLayer){
          return;
        }
        let old = this.$refs.canvasLayer.querySelector('canvas');
        if(old){
          old.replaceWith(value);
        }else{
          Object.assign(value.style, {
            width: '100%',
            height: '100%'
          })
          this.$refs.canvasLayer.append(value);
        }
      };
      if(!this.$refs.canvasLayer){
        this.$nextTick(append);
      }else{
        append();
      }
    },
    'deviceSettings.audiooutput.deviceId': function(deviceId){
      this.setSinkId(deviceId);
    },
    muted: function() {
      this.updateVideoMute();
    },
    loading: function(value){
      if(value){
        return;
      }
      this.checkVideoMuteListener();
    }
  },
  created() {
  },
  async mounted() {
    let deviceId = this.deviceSettings?.audiooutput?.deviceId;
    this.setSinkId(deviceId);
    this.updateVideoMute();
    this.$emit('mounted', this);

    const {roomId} = this.getCamStudyUser();
    await this.getUserStickerList({
      roomId,
      userId: this.user.userId
    })
  },
  destroyed() {
  },
  methods: {
    ...mapActions('coordi', [
      'getUserStickerList',
    ]),
    onEvent(e) {
      this.$emit(e.type, e);

      // console.log('@@@@', e.type, this.$refs.video)
      switch(e.type){
        case 'play':
          if(this.myVideo){
            let track = this.$refs.video.srcObject?.getVideoTracks()[0];
            if(track){
              const canvas = track.GrmTrackUtils().getTrackGenerator().getRenderCanvas();
              if(canvas){
                this.loading = false;
                this.canvas = canvas;
                return;
              }
            }
          }
          break;
        case 'playing':
          this.loading = false;
          this.checkVideoMuteListener();
          break;
        case 'pause':
        case 'stalled':
        case 'emptied':
        case 'error':
          this.loading = true;
          break;
        case 'progress':
          this.loading = e.target.networkState !== 2
          this.checkVideoMuteListener();
          break;
        default:
          break;
      }
    },
    play() {
      return this.$refs.video.play();
    },
    pause() {
      return this.$refs.video.pause();
    },
    setAttribute(attr, value) {
      this.$refs.video.setAttribute(attr, value);
    },
    async setSinkId(deviceId) {
        if(!HTMLAudioElement.prototype.setSinkId){
            // not supported
            return;
        }
        if(deviceId !== '' && !deviceId) return;
        let video = this.$refs.video;
        if(!video) return;

        try{
            if(video.sinkId === deviceId){
              return;
            }

            // default 설정 없이 할 경우 설정되지 않음. 확인 때까지 default 설정 후 재설정
            if(deviceId != 'default'){
              await video.setSinkId('default');
            }
            await video.setSinkId(deviceId);
        }catch(e){
            if(e.message?.includes('aborted')){
                console.warn(e);
            }else{
                console.error(e);
                throw e;
            }
        }
    },
    updateVideoMute(){
      if(this.$refs.video) {
        this.$refs.video.muted = this.muted;
      }
    },

    checkVideoMuteListener () {
      if(this.loading){
        return;
      }

      const track = this.videoTrack;
      if(!track) return;
      // if(!track || track.muted) return;

      this._checkVideoMuteListener = this._checkVideoMuteListener || ((e) => {
        let track = e.target;
        if(track !== this.videoTrack){
          track.removeEventListener('mute', this._checkVideoMuteListener);
          track.removeEventListener('unmute', this._checkVideoMuteListener2);
          return;
        }

        console.log('# video muted:', this.user)
        this._cv_timer = setTimeout(() => {
          this.loading = true;
        }, 1000);

        this._checkVideoMuteListener2 = this._checkVideoMuteListener2 || (e => {
          console.log('# video unmute:', this.user)
          clearTimeout(this._cv_timer);
          this.loading = false;
        });
        track.removeEventListener('unmute', this._checkVideoMuteListener2);
        track.addEventListener('unmute', this._checkVideoMuteListener2, {once: true});
      });
      track.removeEventListener('mute', this._checkVideoMuteListener);
      track.addEventListener('mute', this._checkVideoMuteListener);
    }
  },
}

</script>

<style lang="scss" scoped>
.room-video-wrapper {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
}
.room-video {
  width: 100%;
  height: 100%;
  pointer-events: none;
  border-radius: 12px;
  object-fit: cover;
  overflow: hidden;

  canvas {
    width: 100%;
    height: 100%;
  }
}
.user-sticker-layer{
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
}

.user-profile-image-container{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  aspect-ratio: 1/1;
  border-radius: 12px;
  background: linear-gradient(180deg, #121212 0%, #313131 100%);
}
.user-profile-image {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40%;
  border-radius: 50%;
  height: 40%;
  overflow: hidden;
  background-color: #000;
  //display: flex;
  //justify-content: center;
  //align-items: center;
  &.blank-profile-image {
    background-size: auto 100%;
  }

  &.hide {
    display: none;
  }
}
</style>